// src/data/normalizeId.js
export function normalizeId(str) {
  if (!str) return "";

  return str
    .toLowerCase()
    .normalize("NFD")                 // break accented characters
    .replace(/[\u0300-\u036f]/g, "")  // remove accents
    .replace(/[^a-z0-9]/g, "");       // remove spaces, hyphens, punctuation
}
